module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "14",
      "viewBox": "0 0 16 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.3948 12.84C14.0662 11.5328 15.1412 9.49711 15.1412 7.21139C15.1412 3.26675 11.9537 0.0756764 8.00904 0.0703192C4.05904 0.0649621 0.855469 3.26318 0.855469 7.21139C0.855469 9.44711 1.88225 11.4417 3.49118 12.7507C3.55368 12.8007 3.64475 12.79 3.69475 12.7275L4.39833 11.8257C4.44654 11.765 4.43583 11.6775 4.3769 11.6275C4.23226 11.5096 4.09297 11.3828 3.95904 11.2489C3.43693 10.7286 3.02089 10.1118 2.73404 9.43282C2.43404 8.73103 2.28404 7.98282 2.28404 7.21139C2.28404 6.43996 2.43404 5.69175 2.73225 4.98818C3.01975 4.30782 3.43226 3.69711 3.95726 3.17211C4.48226 2.64711 5.09297 2.23461 5.77333 1.94711C6.47868 1.64889 7.2269 1.49889 7.99833 1.49889C8.76976 1.49889 9.51797 1.64889 10.2215 1.94711C10.9019 2.23461 11.5126 2.64711 12.0376 3.17211C12.5626 3.69711 12.9751 4.30782 13.2626 4.98818C13.5608 5.69175 13.7108 6.43996 13.7108 7.21139C13.7108 7.98282 13.5608 8.73104 13.2626 9.43461C12.9758 10.1136 12.5597 10.7304 12.0376 11.2507C11.8715 11.4167 11.6965 11.5721 11.5144 11.715L10.7876 10.7846C10.7712 10.7633 10.749 10.7471 10.7238 10.7379C10.6985 10.7286 10.6712 10.7267 10.6449 10.7323C10.6186 10.7379 10.5944 10.7508 10.5751 10.7695C10.5558 10.7883 10.5422 10.8121 10.5358 10.8382L9.82868 13.7346C9.80726 13.8239 9.87511 13.9114 9.96618 13.9114L12.9483 13.9257C13.068 13.9257 13.1358 13.7882 13.0608 13.6953L12.3948 12.84Z",
      "fill": "black",
      "fill-opacity": "0.85"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99117b98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/ResetIcon.vue
// module id = 1513
// module chunks = 159